import { heading } from "./heading"
import { text } from "./text"

export { heading, text }
